import MonitoringAlertList from './MonitoringAlertList'
import MonitoringAlertShow from './MonitoringAlertShow'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'

export default {
  list: MonitoringAlertList,
  show: MonitoringAlertShow,
  icon: NotificationsActiveIcon,
}
